import { Grid, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import Button from '@mui/material/Button';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { useMaterialUIController, setReturnRequestContext } from "context";
import configurationContext from "contextConfig";
import { RETURN_REQUEST } from "constants.js";
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';

function List() {
    const navigate = useNavigate();
    const { pageNo } = useParams();
    var pageSelected = 1;
    const MyContext = useContext(configurationContext);
    const [controller, dispatch,initialState] = useMaterialUIController();
    const { returnRequestContext } = controller;
    if (typeof pageNo !== "undefined") {
        const parts = pageNo.split("-");
        pageSelected = parts[1].trim();
    }

    const { t } = useTranslation();
    const BASE = Config.BASE;
    const TOKEN = window.localStorage.getItem('token');
    const [returnRequestData, setData] = useState({});
    const [responseResultCount, setResponseResultCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isReturnRequestContextChanged, setReturnRequestContextChanged] = useState(false);

    const data = () => {
        setIsLoading(true);
        toast.dismiss();

        axios({
            url: BASE + "api/return/list?pageSelected=" + pageSelected + "&statusFilter=" + returnRequestContext.statusFilter + "&orderBy=" + returnRequestContext.orderBy + "&orderValue=" + returnRequestContext.orderValue + "&searchBy=" + returnRequestContext.searchBy + "&searchValue=" + returnRequestContext.searchValue,
            method: "GET",
            headers: {
                Authorization: `Bearer ${TOKEN}`,
                function: Config.FUNCTION_KEY
            },
        }).then(function (response) {
            setIsLoading(false);
            if (response.status == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    setData(response.data);
                    if (response.data.data.totalCount)
                        setResponseResultCount(response.data.data.totalCount);
                }
                else {
                    toast.error(t(message))
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(function (error) {
            setIsLoading(false);
            handleErrors(error, t, navigate);
        });
    }

    useEffect(() => {
        data();
    }, [pageNo]);

    const handleResetFilters = () => {
        setReturnRequestContext(dispatch, initialState.returnRequestContext);
        setReturnRequestContextChanged(false);
        if (typeof pageNo === "undefined")
          navigate("/returns/list/page-1");
        else
          navigate("/returns/list");
      };

      useEffect(() => {
        const hasChanged = Object.keys(returnRequestContext).some(
          key => returnRequestContext[key] !== initialState.returnRequestContext[key]
        );
        setReturnRequestContextChanged(hasChanged);
      }, [returnRequestContext]);

    const columns = [
        { Header: t("id"), accessor: "id", align: "left" },
        { Header: t("orderId"), accessor: "orderId", align: "left" },
        { Header: t("vendorShopName"), accessor: "vendorShopName", align: "left" },
        { Header: t("customerEmail"), accessor: "customerEmail", align: "left" },
        { Header: t("productTitle"), accessor: "productTitle", align: "left" },
        { Header: t("quantity"), accessor: "quantity", align: "left" },
        { Header: t("status"), accessor: "status", align: "left" },
        { Header: t("action"), accessor: "action", align: "left" }

    ];
    const finalObj = [];
    if (returnRequestData.data && returnRequestData.data.rows) {
        let returnRequests = returnRequestData.data.rows;
        for (const rowKey in returnRequestData.data.rows) {
            let returnRecord = returnRequests[rowKey];
            if (returnRecord.id > 0) {
                let tempObj = {
                    id: '#' + returnRecord.id,
                    orderId: '#' + returnRecord.orderId,
                    vendorShopName: returnRecord.vendorShopName,
                    customerEmail: returnRecord.customerEmail,
                    productTitle: returnRecord.productTitle,
                    quantity: returnRecord.quantity,
                    status: <span className={'statusD' + returnRecord.status}>
                        {(returnRecord.status == RETURN_REQUEST.REQUESTED) ? <span>{t('requested')}</span> :
                            (returnRecord.status == RETURN_REQUEST.OPEN) ? <span>{t('open')}</span> :
                                (returnRecord.status == RETURN_REQUEST.DECLINED) ? <span>{t('declined')}</span> :
                                    (returnRecord.status == RETURN_REQUEST.CLOSED) ? <span>{t('closed')}</span> : null}</span>,
                    action: <span className="actionClass">
                        <Link onClick={(event) => { event.preventDefault(); navigate("/returns/view/" + returnRecord.id) }}>
                            <Box className="squareBoxView paddingRight5">
                                <VisibilityIcon color="success" fontSize="medium" titleAccess={t("view")} />
                            </Box>
                        </Link>
                    </span>
                };
                finalObj.push(tempObj);
            }
        }
    }
    const rows = finalObj;

    return (
        <DashboardLayout>
            <DashboardNavbar pageTitle={t("returnRequest")} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {(Object.keys(returnRequestData).length > 0) ?
                <MDBox pt={6} pb={3} className="ContentSectionBox">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                                <Grid container className="FilterSectionBox" spacing={2}>
                                    <Grid item md={2} sm={3} xs={6}>
                                        <MDInput
                                            select
                                            name="statusFilter"
                                            label={t('status')}
                                            value={returnRequestContext.statusFilter}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            className="ManageProductTopSecip"
                                            onChange={(obj) => {
                                                setReturnRequestContext(dispatch, { ...returnRequestContext, statusFilter: obj.target.value });
                                            }}
                                            fullWidth
                                        >
                                            <MenuItem value='all'>{t('all')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.REQUESTED}>{t('requested')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.OPEN}>{t('open')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.DECLINED}>{t('declined')}</MenuItem>
                                            <MenuItem value={RETURN_REQUEST.CLOSED}>{t('closed')}</MenuItem>
                                        </MDInput>
                                    </Grid>
                                    <Grid item md={2} sm={3} xs={6} >
                                        <MDInput
                                            select
                                            name="searchBy"
                                            label={t('searchBy')}
                                            value={returnRequestContext.searchBy}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            onChange={(obj) => {
                                                if (obj.target.value == 'none') {
                                                    setReturnRequestContext(dispatch, { ...returnRequestContext, searchValue: '', searchBy: obj.target.value });
                                                }
                                                else
                                                    setReturnRequestContext(dispatch, { ...returnRequestContext, searchBy: obj.target.value });
                                            }} fullWidth
                                        >
                                            <MenuItem value={'none'}>{t('none')}</MenuItem>
                                            <MenuItem value={"orderId"}>{t('orderId')}</MenuItem>
                                            <MenuItem value={'vendorShopName'}>{t('vendorShopName')}</MenuItem>
                                            <MenuItem value={'customerEmail'}>{t('customerEmail')}</MenuItem>
                                        </MDInput>
                                    </Grid>

                                    {returnRequestContext.searchBy != 'none' ?        
                                        <Grid item md={2} sm={3} xs={6} >
                                            <FormControl >
                                                <MDInput
                                                    key={'searchValue'}
                                                    value={returnRequestContext.searchValue}
                                                    type="text"
                                                    name="searchValue"
                                                    label={t('searchInput')}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onChange={(obj) => {
                                                        setReturnRequestContext(dispatch, { ...returnRequestContext, searchValue: obj.target.value });
                                                    }} fullWidth />
                                            </FormControl>
                                        </Grid>
                                    : <></>}

                                    <Grid item md={2} sm={3} xs={6} >
                                        <MDInput
                                            select
                                            name="orderBy"
                                            value={returnRequestContext.orderBy}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            label={t('orderBy')}
                                            onChange={(obj) => {
                                                setReturnRequestContext(dispatch, { ...returnRequestContext, orderBy: obj.target.value });
                                            }} fullWidth
                                        >
                                            <MenuItem value={'id'}>{t('id')}</MenuItem>
                                        </MDInput>
                                    </Grid>
                                    <Grid item xs={12} sm={isReturnRequestContextChanged?1:2} md={isReturnRequestContextChanged?1:2}>
                                        <MDInput
                                            select
                                            name="orderValue"
                                            value={returnRequestContext.orderValue}
                                            InputProps={{
                                                classes: { root: "filterStyle" },
                                            }}
                                            label={t('order')}
                                            onChange={(obj) => {
                                                setReturnRequestContext(dispatch, { ...returnRequestContext, orderValue: obj.target.value });
                                            }}
                                            fullWidth
                                        >
                                            <MenuItem value={'DESC'}>{t('desc')}</MenuItem>
                                            <MenuItem value={'ASC'}>{t('asc')}</MenuItem>
                                        </MDInput>
                                    </Grid>

                                    <Grid item xs={12} sm={isReturnRequestContextChanged?2:1} md={isReturnRequestContextChanged?2:1}>
                                        <FormControl className="filterSubmit">
                                            <MDButton disableRipple
                                            onClick={() => {
                                                navigate("/returns/list");
                                                if (typeof pageNo === "undefined")
                                                  data();
                                                 }} key="submit" type="submit" color="info" size="small" className="SubmitButton">{t('submit')}</MDButton>
                                            {isReturnRequestContextChanged && (
                                                <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple>{t('reset')}</MDButton>
                                            )}
                                        </FormControl>

                                        



                                    </Grid>
                                </Grid>
                            </MDBox>
                            <MDBox pt={3}>
                                <DataTable
                                    table={{ columns, rows }}
                                    isSorted={false}
                                    showTotalEntries={true}
                                    responseResultCount={responseResultCount}
                                    paginationSize={MyContext.paginationSize}
                                    paginationLink={"/returns/list/page-"}
                                    pageSelected={pageSelected}
                                />
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
                :
                null
            }
        </DashboardLayout>
    );
}

export default List;
